export function buildSteps(lesson) {
  if (!lesson) return [];
  const steps = [];
  steps.push({ type: 'welcome' });
  if (lesson.welcome?.why_it_matters) steps.push({ type: 'why' });
  (lesson.sections || []).forEach((s, idx) => steps.push({ type: 'section', index: idx }));
  if (lesson.therapist_perspective) steps.push({ type: 'therapist' });
  if (lesson.evidence_spotlight?.finding) steps.push({ type: 'evidence' });
  if (lesson.scenario?.setup) steps.push({ type: 'scenario' });
  if (lesson.activity) steps.push({ type: 'activity' });
  if (lesson.action_plan?.today) steps.push({ type: 'challenge' });
  steps.push({ type: 'complete' });
  return steps;
}

export function buildLegacySteps(lesson) {
  const steps = [{ type: 'legacy_welcome' }];
  if (lesson.body) steps.push({ type: 'legacy_body' });
  if (lesson.reflection) steps.push({ type: 'legacy_reflection' });
  steps.push({ type: 'complete' });
  return steps;
}
